import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import homepageService from "../services/homepage";
import settingService from "../services/setting";
import { swalSuccess, swalError, swalDelete } from "../utils/swal";
import { API_URL } from "../config";

function ManageCarousel({ session }) {
    const { t } = useTranslation();
    const [slides, setSlides] = useState([]);
    const [image, setImage] = useState(null);
    const [title, setTitle] = useState("");
    const [link, setLink] = useState("");
    const [speed, setSpeed] = useState(5000);

    useEffect(() => {
        fetchSlides();
        settingService.get().then(res => {
            if (res.data && res.data.carouselSpeed) setSpeed(res.data.carouselSpeed);
        });
    }, []);

    const fetchSlides = () => {
        homepageService.getSlides(session.token).then(res => setSlides(res.data));
    };

    const handleUpload = e => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("image", image);
        formData.append("title", title);
        formData.append("link", link);

        homepageService.createSlide(session.token, formData).then(res => {
            if (res.error) swalError(res.error);
            else {
                swalSuccess(t("slide_added"));
                fetchSlides();
                setTitle("");
                setLink("");
                setImage(null);
            }
        });
    };

    const handleDelete = id => {
        swalDelete(() => {
            homepageService.deleteSlide(session.token, id).then(() => {
                swalSuccess(t("deleted"));
                fetchSlides();
            });
        });
    };

    const handleUpdateSpeed = () => {
        settingService.updateCarouselSpeed(session.token, speed).then(() => {
            swalSuccess(t("speed_updated"));
        });
    };

    return (
        <div className="container mt-4">
            <h3>{t("manage_carousel_title")}</h3>

            <div className="card p-3 mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">{t("carousel_settings")}</h5>
                </div>
                <div className="form-inline">
                    <label className="mr-2">{t("slide_speed")}</label>
                    <input
                        type="number"
                        className="form-control mr-3"
                        value={speed}
                        onChange={e => setSpeed(Number(e.target.value))}
                    />
                    <button className="btn btn-secondary" onClick={handleUpdateSpeed}>{t("update_speed")}</button>
                    <small className="text-muted ml-3">{t("slide_speed_help")}</small>
                </div>
            </div>

            <div className="card p-3 mb-4">
                <h5>{t("add_new_slide")}</h5>
                <form onSubmit={handleUpload}>
                    <div className="form-group">
                        <label>{t("title_optional")}</label>
                        <input className="form-control" value={title} onChange={e => setTitle(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label>{t("slide_link")}</label>
                        <input className="form-control" value={link} onChange={e => setLink(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label>{t("label_images")}</label>
                        <input type="file" className="form-control-file" onChange={e => setImage(e.target.files[0])} required />
                    </div>
                    <button className="btn btn-primary" type="submit">{t("add_slide")}</button>
                </form>
            </div>

            <div className="row">
                {slides.map(slide => (
                    <div className="col-md-4 mb-3" key={slide._id}>
                        <div className="card">
                            <img src={`${API_URL.replace(/\/+$/, '')}/images/carousel/${slide.image}`} className="card-img-top" style={{ height: '150px', objectFit: 'cover' }} />
                            <div className="card-body">
                                <h5 className="card-title">{slide.title || t("no_title")}</h5>
                                <p className="card-text text-muted">{slide.link}</p>
                                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(slide._id)}>{t("btn_delete")}</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

const mapStateToProps = store => ({ session: store.session });
export default connect(mapStateToProps)(ManageCarousel);
